const INITIAL_STATE = {
    pesquisa: "",
    listaApp: [],
    areaPesquisaAberta: false,
    indexCardAberto: -1,
    estado: 'aberto',
    tituloPainel: ['Meu','INSS'],
    mensagem: '',
    esperandoSolicitacao: false,
    erro: false
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type){

        case 'CALENDARIO_BENEFICIO_SOLICITADO':
            return {...state, esperandoSolicitacao: true, mensagem: '', erro: false}
        case 'CALENDARIO_BENEFICIO_CARREGADO':
            return {...state, esperandoSolicitacao: false, mensagem: 'sucesso', erro: false};
        case 'CALENDARIO_BENEFICIO_VOLTAR':
            return {...state, esperandoSolicitacao: false, mensagem: '', erro: false}
        case 'CALENDARIO_BENEFICIO_ERRO':
            return {...state, esperandoSolicitacao: false, mensagem: 'erro', erro: true};

        default:
            return state;
    }
}